/** Empty name rows when adding a language — matches CourseHistoryDetails prior switch logic. */

export function stubGeneralTitle(lid, v) {
  return {
    name: v,
    description: '',
    guest_referee_title: '',
    guest_referee_description: '',
    referee_description: '',
    language: lid,
  };
}

export function stubGeneralDescription(lid, data) {
  return { name: '', description: data, language: lid };
}

export function stubRefereeTitle(lid, v) {
  return {
    referee_title: v,
    guest_referee_title: '',
    guest_referee_description: '',
    description: '',
    referee_description: '',
    language: lid,
  };
}

export function stubRefereeDescription(lid, data) {
  return { name: '', referee_description: data, language: lid };
}

export function stubGuestTitle(lid, v) {
  return {
    guest_referee_title: v,
    guest_referee_description: '',
    referee_title: '',
    description: '',
    referee_description: '',
    language: lid,
  };
}

export function stubGuestDescription(lid, data) {
  return { name: '', guest_referee_description: data, language: lid };
}

export function stubTop10Title(lid, v) {
  return {
    top10_title: v,
    guest_referee_title: '',
    guest_referee_description: '',
    description: '',
    referee_description: '',
    language: lid,
  };
}

export function stubTop10Description(lid, data) {
  return { name: '', top10_description: data, language: lid };
}

export function stubTop30Title(lid, v) {
  return {
    top30_title: v,
    guest_referee_title: '',
    guest_referee_description: '',
    description: '',
    referee_description: '',
    language: lid,
  };
}

export function stubTop30Description(lid, data) {
  return { name: '', top30_description: data, language: lid };
}
